@if (state.composeOpen()) {
<div class="pec-compose-modal" (mousedown)="close()">
  <div class="pec-compose-panel" (mousedown)="$event.stopPropagation()">
    <!-- Header -->
    <div class="pec-compose-head">
      <div class="pec-compose-title">
        <pec-icon name="compose" [size]="16" />
        {{ titleLabel() }}
      </div>
      <div class="pec-compose-head-actions">
        <button class="pec-icon-btn-sm" (click)="close()">
          <pec-icon name="x" [size]="14" />
        </button>
      </div>
    </div>

    <!-- Scrollable body -->
    <div class="pec-compose-scroll">
      <!-- Da -->
      <div class="pec-compose-field">
        <label>Da</label>
        <select [(ngModel)]="fromMailbox">
          @for (mb of mailboxService.mailboxes(); track mb.email) {
          <option [value]="mb.email">{{ mb.email }}</option>
          }
        </select>
      </div>

      <!-- A -->
      <div class="pec-compose-field pec-compose-field-to">
        <label>A</label>
        <div class="pec-compose-to-row">
          <div class="pec-suggest-wrap">
            <div class="pec-recipient-box">
              @for (email of toChips(); track email) {
              <span class="pec-recipient-chip">
                {{ email }}
                <button type="button" (click)="removeChip('to', email)">
                  <pec-icon name="x" [size]="10" />
                </button>
              </span>
              }
              <input
                type="text"
                [(ngModel)]="to"
                placeholder="Aggiungi destinatario"
                (focus)="activeSuggestField.set('to')"
                (input)="activeSuggestField.set('to')"
                (blur)="onRecipientBlur('to')"
              />
            </div>
            @if (suggestionsFor('to').length > 0) {
            <div class="pec-suggest-dropdown">
              @for (c of suggestionsFor('to'); track c.email) {
              <div
                class="pec-suggest-item"
                (mousedown)="$event.preventDefault()"
                (click)="selectSuggestion('to', c)"
              >
                <div class="pec-ab-avatar">{{ contactInitials(c.nome, c.email) }}</div>
                <div>
                  <div class="pec-ab-item-name">{{ c.nome || c.email }}</div>
                  <div class="pec-ab-item-sub">{{ c.email }}</div>
                </div>
              </div>
              }
            </div>
            }
          </div>
          @if (recipients().length > 1) {
          <span class="pec-rec-count">+{{ recipients().length }} destinatari</span>
          }
          <button
            type="button"
            class="pec-cc-toggle"
            [class.is-active]="showCc()"
            (click)="showCc.update(v => !v)"
          >
            Cc
          </button>
          <button class="pec-btn-rubrica" type="button" (click)="openAddressBook()">
            <pec-icon name="users" [size]="13" />
            Rubrica
          </button>
        </div>
      </div>

      <!-- Cc -->
      @if (showCc()) {
      <div class="pec-compose-field pec-compose-field-to">
        <label>Cc</label>
        <div class="pec-compose-to-row">
          <div class="pec-suggest-wrap">
            <div class="pec-recipient-box">
              @for (email of ccChips(); track email) {
              <span class="pec-recipient-chip">
                {{ email }}
                <button type="button" (click)="removeChip('cc', email)">
                  <pec-icon name="x" [size]="10" />
                </button>
              </span>
              }
              <input
                type="text"
                [(ngModel)]="cc"
                placeholder="Aggiungi destinatari in copia"
                (focus)="activeSuggestField.set('cc')"
                (input)="activeSuggestField.set('cc')"
                (blur)="onRecipientBlur('cc')"
              />
            </div>
            @if (suggestionsFor('cc').length > 0) {
            <div class="pec-suggest-dropdown">
              @for (c of suggestionsFor('cc'); track c.email) {
              <div
                class="pec-suggest-item"
                (mousedown)="$event.preventDefault()"
                (click)="selectSuggestion('cc', c)"
              >
                <div class="pec-ab-avatar">{{ contactInitials(c.nome, c.email) }}</div>
                <div>
                  <div class="pec-ab-item-name">{{ c.nome || c.email }}</div>
                  <div class="pec-ab-item-sub">{{ c.email }}</div>
                </div>
              </div>
              }
            </div>
            }
          </div>
          <button
            class="pec-icon-btn-sm"
            type="button"
            title="Scegli i destinatari in copia dalla rubrica"
            (click)="openAddressBook('cc')"
          >
            <pec-icon name="search" [size]="13" />
          </button>
          <button
            class="pec-icon-btn-sm"
            type="button"
            title="Chiudi campo Cc"
            (click)="showCc.set(false)"
          >
            <pec-icon name="x" [size]="13" />
          </button>
        </div>
      </div>
      }

      <!-- Oggetto -->
      <div class="pec-compose-field">
        <label>Oggetto</label>
        <input type="text" [(ngModel)]="subject" placeholder="Oggetto della comunicazione" />
      </div>

      <!-- Body area -->
      <div class="pec-compose-body">
        <!-- AI Insights box -->
        @if (aiInsights) {
        <div class="pec-compose-ai-box">
          <div class="pec-compose-ai-box-head">
            <pec-icon name="sparkle" [size]="12" />
            <span>AI INSIGHTS · messaggio originale</span>
            <span class="pec-live-pill"><span class="pec-live-dot"></span>ALLEGATO</span>
          </div>
          <div class="pec-compose-ai-box-grid">
            <div class="pec-compose-ai-box-cell">
              <div class="pec-compose-ai-box-k">Categorizzazione</div>
              <div class="pec-compose-ai-box-v">{{ aiInsights.category }}</div>
              <div class="pec-compose-ai-box-bar">
                <div [style.width.%]="aiInsights.confidence"></div>
              </div>
              <div class="pec-compose-ai-box-conf">Confidenza {{ aiInsights.confidence }}%</div>
            </div>
            <div class="pec-compose-ai-box-cell">
              <div class="pec-compose-ai-box-k">Urgenza rilevata</div>
              <div class="pec-compose-ai-box-urg" [class]="'pec-urg-' + aiInsights.urgency">
                {{ aiInsights.urgency === 'alta' ? 'ALTA' : aiInsights.urgency === 'media' ? 'MEDIA'
                : 'BASSA' }}
              </div>
            </div>
          </div>
          @if (aiInsights.keywords && aiInsights.keywords.length > 0) {
          <div class="pec-compose-ai-box-kws">
            @for (kw of aiInsights.keywords; track $index) {
            <span class="pec-kw">{{ kw }}</span>
            }
          </div>
          }
          <div class="pec-compose-ai-box-summary">
            <div class="pec-compose-ai-box-k">Sintesi generata</div>
            <div class="pec-compose-ai-box-summary-txt">{{ aiInsights.summary }}</div>
          </div>
        </div>
        }

        <!-- Protocol block -->
        @if (protocol()) {
        <div class="pec-body-proto-block">
          <div class="pec-body-proto-label">
            <pec-icon name="stamp" [size]="10" />
            PROTOCOLLATO
          </div>
          <div class="pec-body-proto-num">Prot. n. {{ protocol()!.num }}</div>
          <div class="pec-body-proto-date">{{ protocol()!.date }}</div>
        </div>
        }

        <!-- Smart compose + textarea -->
        <div class="pec-smart-wrap">
          @if (showGhost) {
          <div class="pec-smart-ghost" aria-hidden="true">{{ suggestion() }}</div>
          }
          <textarea
            #bodyTextarea
            [(ngModel)]="body"
            [class.has-inoltro]="!!inoltro()"
            (keydown)="onBodyKey($event)"
            [placeholder]="'Scrivi il tuo messaggio…'"
          ></textarea>
          @if (showGhost) {
          <div class="pec-smart-hint">
            <pec-icon name="sparkle" [size]="11" />
            <span>Smart Compose</span>
            <button type="button" class="pec-smart-accept" (click)="acceptSuggestion()">
              Inserisci <kbd>Tab ↹</kbd>
            </button>
            <button type="button" class="pec-smart-ignore" (click)="smartDismissed.set(true)">
              Ignora
            </button>
          </div>
          }
        </div>
        <!-- Solo inoltro: riepilogo del messaggio originale, in sola lettura. Fuori da
             .pec-smart-wrap perché il suggerimento Smart Compose ne copre tutta l'area. -->
        @if (inoltro(); as ino) {
        <div class="pec-body-inoltro">
          <!--<div class="pec-inoltro-title">Inoltro del messaggio</div>-->
          <div class="pec-inoltro-title">{{ ino.titolo }}</div>
          <dl class="pec-inoltro-meta">
            <dt>Mittente</dt>
            <dd>{{ ino.mittente }}</dd>
            <dt>Destinatario</dt>
            <dd>{{ ino.destinatario || '—' }}</dd>
            <dt>Oggetto</dt>
            <dd>{{ ino.oggetto || '(nessun oggetto)' }}</dd>
          </dl>
          <div class="pec-inoltro-corpo-label">Corpo</div>
          @if (ino.corpoHtml !== null) {
          <div class="pec-inoltro-corpo is-html" [innerHTML]="ino.corpoHtml"></div>
          } @else {
          <div class="pec-inoltro-corpo">{{ ino.corpoTesto || '(messaggio vuoto)' }}</div>
          }
        </div>
        }
      </div>
    </div>

    <!-- Allegati list -->
    @if (allegati().length > 0) {
    <div class="pec-compose-allegati">
      @for (a of allegati(); track $index; let i = $index) {
      <div class="pec-allegato-chip">
        <pec-icon name="attach" [size]="12" />
        <span class="pec-allegato-nome" [title]="a.nome">{{ a.nome }}</span>
        <button type="button" class="pec-allegato-remove" (click)="removeAllegato(i)">
          <pec-icon name="x" [size]="11" />
        </button>
      </div>
      }
    </div>
    }

    <!-- Footer -->
    <div class="pec-compose-footer">
      <div class="pec-compose-atts">
        <input type="file" multiple #fileInput style="display: none" (change)="onFilesSelected($event)" />
        <button type="button" class="pec-btn-ghost" (click)="triggerFileInput()">
          <pec-icon name="attach" [size]="14" />Allega file
        </button>

        @if (allegatiOriginali().length > 0) {
        <div class="pec-allegati-originali">
          @for (a of allegatiOriginali(); track a.nome) {
          <div class="pec-allegato-chip">
            <pec-icon name="attach" [size]="12" />
            <span class="pec-allegato-nome" [title]="a.nome">{{ a.nome }}</span>
            <button type="button" class="pec-allegato-azione" aria-label="Scarica" title="Scarica"
                    (click)="scaricaAllegatoOriginale(a.nome)">
              <pec-icon name="download" [size]="12" />
            </button>
            <button type="button" class="pec-allegato-azione pec-allegato-azione-rimuovi" aria-label="Rimuovi"
                    title="Rimuovi" (click)="rimuoviAllegatoOriginale(a.nome)">
              <pec-icon name="x" [size]="12" />
            </button>
          </div>
          }
        </div>
        }
      </div>
      <div class="pec-compose-footer-right">
        <button
          type="button"
          class="pec-btn-secondary pec-btn-proto"
          (click)="saveDraft()"
          [disabled]="!canSaveDraft"
        >
          <pec-icon name="drafts" [size]="13" />
          Salva come bozza
        </button>
        <button type="button" class="pec-btn-primary" (click)="send()" [disabled]="!canSend || sending()">
          <pec-icon name="send" [size]="13" />
          Invia PEC
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Address book modal (layered on top) -->
@if (showAb()) {
<div class="pec-ab-modal" (mousedown)="showAb.set(false)">
  <div class="pec-ab-panel" (mousedown)="$event.stopPropagation()">
    <!-- AB Header -->
    <div class="pec-ab-head">
      <div class="pec-ab-title">
        <pec-icon name="address-book" [size]="16" />
        Rubrica · {{ abTarget() === 'cc' ? 'destinatari in copia' : 'selezione destinatari' }}
      </div>
      <button class="pec-icon-btn-sm" type="button" (click)="showAb.set(false)">
        <pec-icon name="x" [size]="14" />
      </button>
    </div>

    <!-- Tabs -->
    <div class="pec-ab-tabs">
      <button
        type="button"
        [class.is-active]="abTab() === 'contacts'"
        (click)="abTab.set('contacts')"
      >
        <pec-icon name="user" [size]="13" /> Contatti <span>{{ contacts().length }}</span>
      </button>
      <button type="button" [class.is-active]="abTab() === 'lists'" (click)="abTab.set('lists')">
        <pec-icon name="list" [size]="13" /> Liste di distribuzione
        <span>{{ distributionLists().length }}</span>
      </button>
    </div>

    <!-- Contacts tab -->
    @if (abTab() === 'contacts') {
    <div class="pec-ab-search">
      <pec-icon name="search" [size]="14" />
      <input
        type="text"
        [ngModel]="abSearch()"
        (ngModelChange)="abSearch.set($event)"
        placeholder="Cerca nome, email o azienda…"
      />
    </div>
    <div class="pec-ab-list">
      @if (contactsLoading()) {
      <div class="pec-ab-empty">Caricamento contatti…</div>
      } @else if (filteredAbContacts().length === 0) {
      <div class="pec-ab-empty">Nessun contatto trovato</div>
      } @else { @for (c of filteredAbContacts(); track c.id) {
      <div
        class="pec-ab-item"
        [class.is-on]="abSelectedIds().has(c.id)"
        (click)="toggleAbContact(c.id)"
      >
        <span class="pec-ab-check">
          @if (abSelectedIds().has(c.id)) {
          <pec-icon name="check" [size]="14" />
          } @else {
          <pec-icon name="plus" [size]="14" />
          }
        </span>
        <div class="pec-ab-avatar">{{ c.initials }}</div>
        <div>
          <div class="pec-ab-item-name">
            {{ c.name }}
            <!--<span class="pec-type-chip" [class]="'pec-type-' + c.kind.toLowerCase()"
              >{{ c.kind }}</span
            >-->
          </div>
          <div class="pec-ab-item-sub">{{ c.email }}</div>
        </div>
      </div>
      } }
    </div>
    }

    <!-- Lists tab -->
    @if (abTab() === 'lists') {
    <div class="pec-ab-lists">
      @for (l of distributionLists(); track l.id) {
      <div
        class="pec-ab-dl"
        [class.is-on]="abSelectedListIds().has(l.id)"
        (click)="toggleAbList(l)"
      >
        <span class="pec-ab-check">
          @if (abSelectedListIds().has(l.id)) {
          <pec-icon name="check" [size]="14" />
          } @else {
          <pec-icon name="plus" [size]="14" />
          }
        </span>
        <div class="pec-ab-dl-icon">
          <pec-icon name="users" [size]="18" />
        </div>
        <div>
          <div class="pec-ab-dl-name">
            {{ l.nome }}
            <span class="pec-ab-dl-count">{{ getListMembers(l).length }} contatti</span>
          </div>
          <div class="pec-ab-dl-desc">{{ l.descrizione }}</div>
          <div class="pec-ab-dl-members">
            @for (m of getListMembers(l).slice(0, 5); track m.id) {
            <span class="pec-ab-dl-chip">{{ m.name }}</span>
            } @if (getListMembers(l).length > 5) {
            <span class="pec-ab-dl-chip">+{{ getListMembers(l).length - 5 }}</span>
            }
          </div>
        </div>
      </div>
      }
    </div>
    }

    <!-- AB Footer -->
    <div class="pec-ab-footer">
      <div class="pec-ab-summary">
        Selezionati: <strong>{{ abSelectedIds().size }}</strong> destinatari @if
        (abSelectedListIds().size > 0) { &nbsp;da
        <strong>{{ abSelectedListIds().size }}</strong> liste }
      </div>
      <div class="pec-ab-footer-actions">
        <button type="button" class="pec-btn-ghost" (click)="showAb.set(false)">Annulla</button>
        <button
          type="button"
          class="pec-btn-primary"
          [disabled]="abSelectedIds().size === 0"
          (click)="confirmAddressBook()"
        >
          <pec-icon name="check" [size]="14" />
          Aggiungi {{ abSelectedIds().size }} {{ abTarget() === 'cc' ? 'in copia' : 'destinatari' }}
        </button>
      </div>
    </div>
  </div>
</div>
}

<!-- Confirm before closing with unsaved changes -->
@if (showCloseConfirm()) {
<div class="pec-ab-modal" (mousedown)="showCloseConfirm.set(false)">
  <div class="pec-confirm-panel" (mousedown)="$event.stopPropagation()">
    <div class="pec-ab-head">
      <div class="pec-ab-title">
        <pec-icon name="drafts" [size]="16" />
        Salvare come bozza?
      </div>
    </div>
    <div class="pec-confirm-body">
      Hai modificato il messaggio. Vuoi salvarlo come bozza prima di uscire, oppure uscire senza
      salvare?
    </div>
    <div class="pec-confirm-actions">
      <button type="button" class="pec-btn-ghost" (click)="discardAndClose()">
        Esci senza salvare
      </button>
      <button type="button" class="pec-btn-primary" (click)="saveDraftAndClose()">
        <pec-icon name="drafts" [size]="13" />
        Salva come bozza
      </button>
    </div>
  </div>
</div>
} }
